import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AccessibilityHiddenImg } from '@skillz/accessibility';
// import LandscapeImg from '../../../../assests/landscapeImg.png';
import classes from './LandscapeMessage.module.css';
import Popup from '../../../../shared/components/ui/popup/Popup';

const LandscapeMessage = () => {

    const [isMobile, setIsMobile] = useState(false);
    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        const checkIfMobile = () => {
            const isMobileUserAgent = /Mobi|Android|iPhone|iPod|Windows Phone/i.test(navigator.userAgent);
            setIsMobile(isMobileUserAgent);
        };

        checkIfMobile();
        window.addEventListener("resize", checkIfMobile);

        return () => window.removeEventListener("resize", checkIfMobile);
    }, []);

    return (
        isMobile ? <div className={classes.LandscapeMessage} >
            <Popup
                dropClassContainer={classes.Popup}
                dropClass={classes.BackdropPopup}
            // accessibilityDescription={texts?.accessibility.notStartedPopup}
            >
                <div className={classes.PopupContent}>
                    {/* <AccessibilityHiddenImg src={LandscapeImg} className={classes.LandscapeImg} /> */}
                    <p className={classes.Bold}>{texts.rotateDevice}</p>
                    <p>{texts.landscapeNotSupported}</p>
                    <p>{texts.rotateDeviceBestExperience}</p>
                </div>
            </Popup>
        </div> : ''
    );
}

export default LandscapeMessage;
